import { web } from "../middleware";

export const leaderboardApi = {
  getLeadership: (params) =>
    web({
      url: "/v3/leaderboard",
      method: "GET",
      params: params,
    }),
};
